import React from "react";
import {
  Box,
  Container,
  Grid,
  Link,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const Footer: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#f5f5f5",
        py: 3,
        borderTop: "1px solid #e0e0e0",
        mt: 4,
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          justifyContent={isMobile ? "center" : "space-between"}
          spacing={2}
          direction={isMobile ? "column" : "row"}
          alignItems="center"
        >
          {isMobile ? (
            // Mobile view - stacked links
            <>
              <Grid item>
                <Link
                  href="https://www.caraccidentcounsel.com/privacy-policy/"
                  underline="hover"
                  color="text.secondary"
                  sx={{ mx: 1 }}
                >
                  Privacy Policy
                </Link>
              </Grid>
              <Grid item>
                <Link
                  href="https://www.caraccidentcounsel.com/terms-of-service/"
                  underline="hover"
                  color="text.secondary"
                  sx={{ mx: 1 }}
                >
                  Terms of Service
                </Link>
              </Grid>
              <Grid item>
                <Link
                  href="https://www.caraccidentcounsel.com/disclaimer/"
                  underline="hover"
                  color="text.secondary"
                  sx={{ mx: 1 }}
                >
                  Disclaimer
                </Link>
              </Grid>
              <Grid item>
                <Link
                  href="https://www.caraccidentcounsel.com/california-privacy-notice/"
                  underline="hover"
                  color="text.secondary"
                  sx={{ mx: 1 }}
                >
                  California Privacy Notice
                </Link>
              </Grid>
            </>
          ) : (
            // Desktop view - horizontal links
            <Grid item>
              <Link
                href="https://www.caraccidentcounsel.com/privacy-policy/"
                underline="hover"
                color="text.secondary"
                sx={{ mx: 1 }}
              >
                Privacy Policy
              </Link>
              <Link
                href="https://www.caraccidentcounsel.com/terms-of-service/"
                underline="hover"
                color="text.secondary"
                sx={{ mx: 1 }}
              >
                Terms of Service
              </Link>
              <Link
                href="https://www.caraccidentcounsel.com/disclaimer/"
                underline="hover"
                color="text.secondary"
                sx={{ mx: 1 }}
              >
                Disclaimer
              </Link>
              <Link
                href="https://www.caraccidentcounsel.com/california-privacy-notice/"
                underline="hover"
                color="text.secondary"
                sx={{ mx: 1 }}
              >
                California Privacy Notice
              </Link>
            </Grid>
          )}

          <Grid item>
            <Typography
              variant="body2"
              color="text.secondary"
              align={isMobile ? "center" : "right"}
            >
              © {new Date().getFullYear()} Car Accident Counsel. All rights
              reserved.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
